const React = require('react');
const { bool, string, func, shape } = require('prop-types');
const { Snackbar } = require('@andes/snackbar');
const { ErrorUXSnackbar, SnackbarDuration } = require('error-ux-components');

const SnackBarError = ({ key, message, show, clean, errorContext }) => (errorContext ? (
  <ErrorUXSnackbar show={show} message={message} delay={SnackbarDuration.INFINITE} errorContext={errorContext} />
) : (
  <Snackbar show={show} message={message} delay={2000} color="red" key={key} onChange={clean} />
));

SnackBarError.propTypes = {
  key: string,
  message: string.isRequired,
  show: bool,
  clean: func,
  errorContext: shape({}),
};

SnackBarError.defaultProps = {
  key: null,
  show: false,
};

module.exports = React.memo(SnackBarError);
